import { computed, defineComponent, onMounted, PropType, ref } from "vue";
import { gsap, ScrollTrigger } from "gsap/all";
import { Image } from "@/interfaces/Image";

gsap.registerPlugin(ScrollTrigger);

export default defineComponent({
  props: {
    template: { type: Number, default: 1 },
    image1: { type: Object as PropType<Image>, required: true },
    image2: { type: Object as PropType<Image>, required: false },
    backgroundColor: { type: String, required: false },
  },
  setup(props) {
    const templateAllowsForTwoImages = computed(() => {
      switch (props.template) {
        case 1:
        case 3:
          return false;
        default:
          return true;
      }
    });

    return { templateAllowsForTwoImages };
  },
});
